<template>
  <!-- 申请采购单产品明细 -->
  <a-modal
    title="申请采购单产品明细"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="70%"
    @ok="handleOk"
    @cancel="handleCancel"
    :dialog-style="{ top: '20px' }"
  >
    <div class="myTable">
      <a-button type="primary" style="margin-bottom: 20px;" @click="addProduct" v-if="!flag">添加产品明细</a-button>
      <a-upload
        name="file"
        :multiple="false"
        accept="image/*, .doc, .docx, .xls, .xlsx, .pdf, .rar, .zip, .7z"
        :action="action"
        :headers="headers"
        :data="datar"
        :showUploadList="false"
        @change="handleChange"
        v-if="!flag"
      >
        <a-button
          class="btnHoven"
          style="background-color: #2979ff; color: white; border-radius: 4px!important;"
          @click="batchInc"
        >导入产品明细</a-button>
      </a-upload>

      <a-button
        class="btnHoven"
        style="background-color: #faad14; color: white; border-radius: 4px!important;"
        @click="batchDownload"
        v-if="!flag"
      >excel模板下载</a-button>
      <a-button
        class="btnHoven"
        style="background-color: #FF4D4F; color: white; border-radius: 4px!important;"
        @click="batchDelete"
      >删除</a-button>
      <a-table
        :data-source="dataSource"
        :columns="filterColumn"
        :pagination="false"
        :rowKey="(record,index)=>{return index}"
        :row-selection="{ selectedRowKeys: selection, onChange: rowSelectionChange, getCheckboxProps: getCheckboxProps }"
        size="small"
        bordered
        :components="componentesd"
      >
        <template slot="productName" slot-scope="text, record">
          <a-tooltip
            v-if="record.productName && record.productName.length > 50"
            placement="top"
            title="产品名称长度超出50字，请重新填写"
          >
            <a-icon type="info-circle" :style="{ color: 'red', cursor: 'pointer' }" />
          </a-tooltip>
          <a-tooltip v-if="record.productName" :title="record.productName">
            <span :class="{ 'red-text': record.productName.length > 50 }">{{ record.productName }}</span>
          </a-tooltip>
        </template>
        <template slot="productType" slot-scope="text, record">
          <a-tooltip
            v-if="record.productType && record.productType.length > 50"
            placement="top"
            title="产品型号长度超出50字，请重新填写"
          >
            <a-icon type="info-circle" :style="{ color: 'red', cursor: 'pointer' }" />
          </a-tooltip>
          <a-tooltip v-if="record.productType" :title="record.productType">
            <span :class="{ 'red-text': record.productType.length > 50 }">{{ record.productType }}</span>
          </a-tooltip>
        </template>
        <!-- <template slot="productSpecification" slot-scope="text, record">
          <a-tooltip
            v-if="record.productSpecification && record.productSpecification.length > 50 "
            placement="top"
            title="产品规格长度超出50字，请重新填写"
          >
            <a-icon type="info-circle" :style="{ color: 'red', cursor: 'pointer' }" />
          </a-tooltip>
          <a-tooltip v-if="record.productSpecification" :title="record.productSpecification">
            <span
              :class="{ 'red-text': record.productSpecification.length > 50 }"
            >{{ record.productSpecification }}</span>
          </a-tooltip>
        </template>-->
        <template slot="productUnit" slot-scope="text, record">
          <a-tooltip
            v-if="record.productUnit && record.productUnit.length > 5"
            placement="top"
            title="产品单位长度超出5字，请重新填写"
          >
            <a-icon type="info-circle" :style="{ color: 'red', cursor: 'pointer' }" />
          </a-tooltip>
          <a-tooltip v-if="record.productUnit" :title="record.productUnit">
            <span :class="{ 'red-text': record.productUnit.length > 5 }">{{ record.productUnit }}</span>
          </a-tooltip>
        </template>
        <template slot="productCost" slot-scope="text, record">
          <a-input-number
            :min="0"
            v-model="record.productCost"
            :disabled="isEdit(record)"
            @blur="countTotal(record)"
          />
        </template>
        <template slot="productCount" slot-scope="text, record, index">
          <a-input-number
            v-if="flag"
            :min="1"
            :max="dataSourceCopy[index].productCount"
            v-model="record.productCount"
            @blur="countTotal(record)"
            @change="e => countChange(e, record)"
          />
          <a-input-number
            v-else
            :min="0.1"
            v-model="record.productCount"
            :disabled="isEdit(record)"
            @blur="countTotal(record)"
            @change="e => countChange(e, record)"
          />
        </template>
        <template slot="productRemark" slot-scope="text, record">
          <a-input
            v-model="record.productRemark"
            @change="e => remarkChange(e.target.value, record)"
          />
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <a-popconfirm
            v-if="dataSource.length"
            title="确定删除吗？"
            @confirm="() => onDelete(record.productId,index)"
          >
            <a href="javascript:;" style="color:red;" v-if="!isEdit(record)">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
      <div>共 {{dataSource.length}} 条</div>
    </div>
    <product-list-vue
      style="margin-top: 30px;border: 1px solid #e8e8e8;"
      ref="productListRef"
      v-show="productListVisible"
      :typed="false"
      :isShow="isShow"
      @succ="productListSucc"
      @close="productListClose"
    />
  </a-modal>
</template>

<script>
import productListVue from '../productManage/index.vue'
import { mixin } from '@/mixin/index.js'
import { getQuery } from '@/mixin/getQuery.js'

// import {getProjectNameById, getCustomerNameById} from '../../../utils/index'
export default {
  name: 'AddEdit',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  mixins: [getQuery, mixin],
  components: {
    productListVue
  },
  data () {
    return {
      selection: [],
      dataSource: [],
      dataSourceCopy: [],
      flag: false, // 判断是否从采购申请进入
      columns: [
        {
          title: '产品名称',
          width: 180,
          dataIndex: 'productName',
          ellipsis: true,
          scopedSlots: { customRender: 'productName' },
          align: 'center'
        },
        {
          title: '型号',
          width: 100,
          dataIndex: 'productType',
          ellipsis: true,
          scopedSlots: { customRender: 'productType' },
          align: 'center'
        },
        {
          title: '规格',
          width: 100,
          dataIndex: 'productSpecification',
          ellipsis: true,
          // scopedSlots: { customRender: 'productSpecification' },
          align: 'center'
        },
        {
          title: '单位',
          width: 80,
          dataIndex: 'productUnit',
          ellipsis: true,
          scopedSlots: { customRender: 'productUnit' },
          align: 'center'
        },
        {
          title: '零售价',
          width: 90,
          dataIndex: 'productPrice',
          align: 'center'
        },
        {
          title: '采购价格(折扣)',
          width: 150,
          dataIndex: 'productCost',
          scopedSlots: { customRender: 'productCost' },
          align: 'center'
        },
        {
          title: '数量(悬浮可修改)',
          dataIndex: 'productCount',
          width: 200,
          scopedSlots: { customRender: 'productCount' },
          align: 'center'
          // filterDropdown: (<span></span>),
          // filterIcon: <a-tooltip placement="top" title="数量填写请输入整数"><a-icon type="info-circle" theme="twoTone" style={{ position: 'absolute', top: '12px', right: '5px' }} /></a-tooltip>
        },
        {
          title: '总价',
          width: 90,
          dataIndex: 'productTotalCost',
          align: 'center'
          // filterDropdown: (<span></span>),
          // filterIcon: <a-tooltip placement="top" title="计算方式：采购价*数量"><a-icon type="info-circle" theme="twoTone" style={{ position: 'absolute', top: '12px', right: '2px' }} /></a-tooltip>
        },
        {
          title: '备注',
          width: 90,
          dataIndex: 'productRemark',
          scopedSlots: { customRender: 'productRemark' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      productListVisible: false,
      deleteIds: [],
      addProductClickCount: 0,
      // 导入
      action: this.$baseURL + '/purchaseDetail/importExcel',
      headers: {
        Authentication: this.$store.state.account.token
      },
      datar: {
        refType: '6',
        refId: ''
      },
      parentId: 0,
      isShow: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  created () {
    this.geTableColumn('purchaseProductDetail')
  },
  mounted () {
    this.$emit('onClickView')
  },
  methods: {
    setTableList (listVal) {
      if (listVal.length) {
        this.dataSource = listVal
        // getProjectNameById(this.dataSource.projectId).then(res => {
        //   this.$set(this.dataSource, 'projectName', res)
        // })
        // getCustomerNameById(this.dataSource.customerId).then(res => {
        //   this.$set(this.dataSource, 'customerName', res)
        // })
      } else {
        this.dataSource = []
      }
    },
    isShowChange () {
      this.isShow = true
      // this.columns = [
      //   {
      //     title: '产品名称',
      //     width: '15%',
      //     dataIndex: 'productName',
      //     ellipsis: true,
      //     scopedSlots: { customRender: 'productName' },
      //     align: 'center'
      //   },
      //   {
      //     title: '型号',
      //     dataIndex: 'productType',
      //     ellipsis: true,
      //     scopedSlots: { customRender: 'productType' },
      //     align: 'center'
      //   },
      //   {
      //     title: '规格',
      //     dataIndex: 'productSpecification',
      //     ellipsis: true,
      //     // scopedSlots: { customRender: 'productSpecification' },
      //     align: 'center'
      //   },
      //   {
      //     title: '单位',
      //     dataIndex: 'productUnit',
      //     ellipsis: true,
      //     scopedSlots: { customRender: 'productUnit' },
      //     align: 'center'
      //   },
      //   {
      //     title: '零售价',
      //     dataIndex: 'productPrice',
      //     align: 'center'
      //   },
      //   // {
      //   //   title: '采购价格(折扣)',
      //   //   width: 150,
      //   //   dataIndex: 'productCost',
      //   //   scopedSlots: { customRender: 'productCost' },
      //   //   align: 'center'
      //   // },
      //   {
      //     title: '数量(悬浮可修改)',
      //     dataIndex: 'productCount',
      //     width: 200,
      //     scopedSlots: { customRender: 'productCount' },
      //     align: 'center'
      //     // filterDropdown: (<span></span>),
      //     // filterIcon: <a-tooltip placement="top" title="数量填写请输入整数"><a-icon type="info-circle" theme="twoTone" style={{ position: 'absolute', top: '12px', right: '5px' }} /></a-tooltip>
      //   },
      //   {
      //     title: '总价',
      //     dataIndex: 'productTotalCost',
      //     align: 'center'
      //     // filterDropdown: (<span></span>),
      //     // filterIcon: <a-tooltip placement="top" title="计算总价=>采购价为0时 总价=零售价*数量  采购价不为0时 总价=采购价*数量"><a-icon type="info-circle" theme="twoTone" style={{ position: 'absolute', top: '12px', right: '2px' }} /></a-tooltip>
      //   },
      //   {
      //     title: '备注',
      //     dataIndex: 'productRemark',
      //     scopedSlots: { customRender: 'productRemark' },
      //     align: 'center'
      //   },
      //   {
      //     title: '操作',
      //     dataIndex: 'operation',
      //     scopedSlots: { customRender: 'operation' },
      //     align: 'center'
      //   }
      // ]
    },
    countTotal (rowVal, index) {
      if (!rowVal.productCost) rowVal.productCost = 0
      // console.log(this.dataSourceCopy[index], 'index')
      if (this.isShow) { // 采购申请
        rowVal.productTotalCost = parseFloat((rowVal.productPrice * rowVal.productCount).toFixed(4))
      } else { // 采购单
        rowVal.productTotalCost = parseFloat((rowVal.productCost * rowVal.productCount).toFixed(4))
      }
      // 计算总价 采购价为0时 总价=零售价*数量  采购价不为0时 总价=采购价*数量
      // if (rowVal.productCost === 0) {
      //   // rowVal.productTotalCost = rowVal.productPrice * rowVal.productCount
      //   rowVal.productTotalCost = parseFloat((rowVal.productPrice * rowVal.productCount).toFixed(4))
      // } else {
      //   // rowVal.productTotalCost = rowVal.productCost * rowVal.productCount
      //   rowVal.productTotalCost = parseFloat((rowVal.productCost * rowVal.productCount).toFixed(4))
      // }
    },
    countChange (val, rowObj) {
      // 节流函数
      rowObj.productCount = val
    },
    remarkChange (val, rowObj) {
      // 节流函数
      rowObj.productRemark = val
    },
    addProduct () {
      if (this.addProductClickCount === 0) {
        this.productListVisible = true
        setTimeout(() => {
          this.$refs.productListRef.addShowCol(this.dataSource)
        }, 500)
        this.addProductClickCount++
      }
    },
    productListSucc (rowVal) {
      // console.log('添加数据', this.dataSource)
      if (this.isShow) rowVal.productTotalCost = parseFloat((rowVal.productPrice * rowVal.productCount).toFixed(4))
      this.dataSource.push(rowVal)
    },
    rowSelectionChange (selectedRowKeys) {
      this.selection = selectedRowKeys
    },
    getCheckboxProps (record) {
      // console.log(record, 'record', (record.stockInCount || record.stockInCount === 0) && (record.stockOutCount || record.stockOutCount === 0) ? record.stockInCount !== 0 || record.stockOutCount !== 0 : false)
      return {
        props: {
          disabled: this.isEdit(record)
        }
      }
    },
    isEdit (record) { // 判断采购单产品明细能否修改
      return (record.stockInCount || record.stockInCount === 0) && (record.stockOutCount || record.stockOutCount === 0) ? record.stockInCount !== 0 || record.stockOutCount !== 0 : false
    },
    productListClose () {
      this.productListVisible = false
    },
    // 明细导入
    batchInc () {
      this.datar.refId = this.parentId
    },
    // 文件上传
    handleChange (info) {
      // console.log('info=>', info)
      const status = info.file.status
      if (status === 'done') {
        const res = info.file.response
        if (res.status === 0) {
          this.$message.error(res.message)
        } else {
          res.data.forEach((e) => {
            this.dataSource.push({
              productId: e.productId,
              productName: e.productName,
              productType: e.productType,
              productUnit: e.productUnit,
              productCount: e.productCount, // 数量
              productRemark: e.productRemark,
              productCost: e.productCost, // 采购价格
              productPrice: e.productPrice,
              productTotalCost: e.productTotalCost,
              productSpecification: e.productSpecification
            })
          })
          this.$message.success(`文件导入成功！共${res.data.length}条产品数据`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件导入失败，请重试！.`)
        // this.uploadSpinning = false
      }
      // this.dataSource = [...this.dataSource, ...res]
    },
    // 模板下载
    batchDownload () {
      this.$download('/purchaseDetail/exportTemp', { pageSize: -1, pageNum: -1 }, `${new Date().getTime()}excel模板.xlsx`)
    },
    batchDelete () {
      // console.log(this.selection, '==========', this.dataSource)
      if (this.selection.length > 0) {
        const arr = this.selection.sort((a, b) => a - b)
        // console.log(arr, '-------------')
        for (var i = arr.length - 1; i >= 0; i--) {
          let index = arr[i]
          let id = this.dataSource[index].productId
          // console.log(id, 'this.dataSource[index].id', index)
          if (id) this.deleteIds.push(id)
          if (this.flag) {
            this.dataSourceCopy.splice(index, 1)
          }
          this.$refs.productListRef.delRow(id)
          this.dataSource.splice(index, 1)
        }
        this.selection = []
        this.$forceUpdate()
      } else {
        this.$message.warning('请选择你需要删除的数据')
      }
    },
    onDelete (rowId, indexVal) {
      this.dataSource.splice(indexVal, 1)
      this.deleteIds.push(rowId)
      if (this.flag) {
        this.dataSourceCopy.splice(indexVal, 1)
      }
      this.$refs.productListRef.delRow(rowId)
    },
    handleOk () {
      console.log(this.checkList(this.dataSource), 'this.checkList(this.dataSource)')
      if (!this.checkList(this.dataSource)) {
        this.$message.error('格式错误！请重新填写')
        return
      }
      let that = this
      // console.log(this.dataSource, '============')
      if (this.dataSource.some(r => r.productCost === 0)) {
        let length = this.dataSource.filter(r => r.productCost === 0)
        let num = length.length
        // console.log(length, 'length', num)
        this.$confirm({
          content: `产品明细存在${num}项单价的填写为0，对应的总价可能无法有效计入到成本核算，确定是否保存？`,
          centered: true,
          onOk () {
            that.$emit('ok', that.dataSource, that.deleteIds, that.dataSourceCopy)
            that.dataSource = []
            that.dataSourceCopy = []
            that.deleteIds = []
            that.addProductClickCount = 0
            that.productListVisible = false
          },
          onCancel () {

          }
        })
      } else {
        this.$emit('ok', this.dataSource, this.deleteIds, this.dataSourceCopy)
        this.dataSource = []
        this.deleteIds = []
        this.dataSourceCopy = []
        this.addProductClickCount = 0
        this.productListVisible = false
      }
      // this.$emit('ok', this.dataSource, this.deleteIds, this.dataSourceCopy)
      // this.dataSource = []
      // this.dataSourceCopy = []
      // this.deleteIds = []
      // this.addProductClickCount = 0
      // this.productListVisible = false
    },
    handleCancel () {
      this.$emit('close')
      this.dataSource = []
      this.dataSourceCopy = []
      this.deleteIds = []
      this.addProductClickCount = 0
      this.productListVisible = false
    },
    // 规则校验
    checkList (val) {
      return val.every(item => {
        const nameValid = (item.productName || '').length <= 50 // 产品名称≤3字符
        const typeValid = (item.productType || '').length <= 50 // 型号≤3字符
        // const specValid = (item.productSpecification || '').length <= 50 // 规格≤3字符
        const unitValid = (item.productUnit || '').length <= 5 // 单位≤1字符
        return nameValid && typeValid && unitValid
      })
    }
  }
}
</script>

<style lang="less" scoped>
.itemRow {
  border-bottom: dashed 1px #e5e5e5;
  text-align: left;
}

.editable-cell {
  position: relative;
}
.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}
.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}
.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}
.editable-cell-icon {
  line-height: 18px;
  display: none;
}
.editable-cell-icon-check {
  line-height: 28px;
}
.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}
.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}
.editable-add-btn {
  margin-bottom: 8px;
}
.btnHoven:hover {
  border-color: #ff4d4f;
}
.red-text {
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/purchaseRequest/details.vue